import React from 'react'
import moment from 'moment'
import { ShowMoreText } from '../../../shared/ShowMoreText'
import { Button, Checkbox, Icon, message, Modal, Tooltip } from 'antd'
import { removeBatchFromGroup } from '../../../../services/api/3dApi'

const GroupBatchRow = (props) => {
    const { item, key, reload } = props
    const { batches = [], created_at, created_by, id } = item

    const [isOpen, setIsOpen] = React.useState(false)
    const [listBatchDelete, setListBatchDelete] = React.useState([])

    // React.useEffect(() => {
    //     if (!!batches.length) setListBatchDelete(batches)
    // }, [batches])

    const _handleMultipleDelivery = async () => {
        try {
            const promises = listBatchDelete.map(batch => {
                const payload = {
                    pwd: batch.name
                }

                return removeBatchFromGroup(batch.id, payload)
                    .then(response => {
                        const { data, success, error } = response.data
                        if (!success) {
                            return { success: false, batchId: batch.id, error: error, name: batch.name }
                        }
                        return { success: true, batchId: batch.id, name: batch.name }
                    })
                    .catch(e => {
                        return { success: false, batchId: batch.id, error: e.message, name: batch.name }
                    })
            })

            const results = await Promise.all(promises)

            const failedUpdates = []
            const successUpdates = []

            results.forEach(result => {
                if (result.success) {
                    successUpdates.push(result.name)
                } else {
                    failedUpdates.push(result)
                }
            })

            if (!!failedUpdates.length) {
                Modal.info({
                    title: 'Kết quả xóa lô khỏi nhóm',
                    content: (
                        <div>
                            {successUpdates.length > 0 && (
                                <div className="mt-2">
                                    <h5 className="text-success">Xóa lô khỏi nhóm thành công:</h5>
                                    <ul className="pl-4 list-disc">
                                        {successUpdates.map(name => (
                                            <li key={name}>{name}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {failedUpdates.length > 0 && (
                                <div className="mt-2">
                                    <h5 className="text-danger">Có lỗi khi xóa lô khỏi nhóm:</h5>
                                    <ul className="pl-4 list-disc">
                                        {failedUpdates.map(i => (
                                            <li key={i.batchId}>{`${i.name}: ${i.error}`}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    ),
                    okText: 'Đóng',
                    onOk: () => {
                        reload()
                        setListBatchDelete([])
                    },
                })
            } else {
                message.success('Xóa lô khỏi nhóm thành công.')
                reload()
                setListBatchDelete([])
            }
        } catch (error) {
            message.error(error.message)
        }
    }

    return (
        <tr key={key}>
            <td>{`GB-${id}`}</td>
            <td style={{ width: '60%' }}>
                <div className="d-flex align-items-center">
                    {
                        batches.length > 0 &&
                        <Tooltip title="Xóa lô khỏi nhóm">
                            <Icon
                                className='mr-2'
                                type="delete"
                                onClick={() => setIsOpen(true)}
                                style={{ color: '#f01717' }}
                            />
                        </Tooltip>
                    }
                    {
                        !!batches.length ?
                            <div className="ls-batch d-inline-block">
                                <ShowMoreText text={batches.map(i => !!i.name && i.name).filter(Boolean)} />
                            </div> : '-'
                    }
                    <Modal
                        title={<span>Xóa lô khỏi nhóm (<span className='text-danger'>{`GB-${id}`}</span>)</span>}
                        visible={isOpen}
                        onCancel={() => {
                            setIsOpen(false)
                            setListBatchDelete([])
                        }}
                        footer={[
                            <Button key="cancel" onClick={() => {
                                setIsOpen(false)
                                setListBatchDelete([])
                            }}>
                                Hủy
                            </Button>,
                            <Button
                                key="ok"
                                type="primary"
                                onClick={() => {
                                    _handleMultipleDelivery()
                                    setIsOpen(false)
                                }}
                                disabled={!listBatchDelete.length}>
                                Xóa
                            </Button>
                        ]}
                    >
                        <h5 className='mb-2'>Danh sách lô trong nhóm:</h5>
                        {batches.length > 0 ? (
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)'
                            }}>
                                {batches.map(batch => (
                                    <Checkbox
                                        key={batch.id}
                                        className='ml-0'
                                        value={batch.id}
                                        checked={listBatchDelete.some(b => b.id === batch.id)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setListBatchDelete(prev => [...prev, batch])
                                            } else {
                                                setListBatchDelete(prev => prev.filter(b => b.id !== batch.id))
                                            }
                                        }}>
                                        <span>{batch.name}</span>
                                    </Checkbox>
                                ))}
                            </div>
                        ) : (
                            <p>Không có lô nào để xóa.</p>
                        )}
                    </Modal>
                </div>
            </td >
            <td>
                {!!created_at ? moment(created_at).format("HH:mm DD/MM/YYYY") : '-'}
            </td>
            <td >
                {created_by || '-'}
            </td>
        </tr >
    )
}

export default GroupBatchRow